import { render, staticRenderFns } from "./repairDetailPhotos.vue?vue&type=template&id=6676ea1b&scoped=true"
import script from "./repairDetailPhotos.vue?vue&type=script&lang=js"
export * from "./repairDetailPhotos.vue?vue&type=script&lang=js"
import style0 from "./repairDetailPhotos.vue?vue&type=style&index=0&id=6676ea1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676ea1b",
  null
  
)

export default component.exports